import { FormDataUser } from "./Components/FormDataUser";
import { CardHeaderAvatar } from "./Components/CardHeaderAvatar";
import { FormPasswordUser } from "./Components/FormPassword";
import { Grid } from "@mui/material";

export const ProfileUserPage = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CardHeaderAvatar />
      </Grid>

      <Grid item container spacing={3}>
        <Grid item xs={12} sm={7}>
          <FormDataUser />
        </Grid>

        <Grid item xs={12} sm={5}>
          <FormPasswordUser />
        </Grid>
      </Grid>
    </Grid>
  );
};
